import { render, staticRenderFns } from "./TransfersItems.vue?vue&type=template&id=0aa04031&scoped=true"
import script from "./TransfersItems.vue?vue&type=script&lang=js"
export * from "./TransfersItems.vue?vue&type=script&lang=js"
import style0 from "./TransfersItems.vue?vue&type=style&index=0&id=0aa04031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa04031",
  null
  
)

export default component.exports